import { dossiers } from '@/mocks/home';
import { getTone } from '@/pages/home/lib/tone';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function DossierGrid() {
  return (
    <section id="dossier" className="w-full bg-background-100 px-4 py-12 md:px-8 md:py-16">
      <div className="mx-auto max-w-[1280px]">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <SectionHeading
            kicker="Dossier Shelf / 反差档案架"
            index="05 — 最新 6 条"
            title="前一句与后一句，摆在一起看"
            desc="每条档案只保留两行对照：公开呈现的样子，与后来被记录的片段。不做评价，只做并排。"
          />
          <a
            href="#topics"
            className="mb-1 inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-foreground-950 px-4 py-2 font-label text-sm text-foreground-950 transition-colors hover:bg-foreground-950 hover:text-background-50"
          >
            按身份筛选
            <i className="ri-filter-3-line" />
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {dossiers.map((item) => {
            const tone = getTone(item.tagTone);
            return (
              <article
                key={item.id}
                className="flex flex-col justify-between rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-foreground-300"
              >
                <div>
                  <div className="flex items-center justify-between gap-3">
                    <span className={`font-label text-[11px] tracking-widest ${tone.text}`}>{item.code}</span>
                    <span className={`rounded-full px-2.5 py-0.5 font-label text-[11px] ${tone.softBg} ${tone.softText}`}>
                      {item.role}
                    </span>
                  </div>

                  <h3 className="mt-3 font-heading text-lg font-bold text-foreground-950">
                    <a href="#dossier" className="transition-colors hover:text-primary-600">
                      {item.name}
                    </a>
                  </h3>

                  <div className="mt-4 space-y-2">
                    <div className="rounded-md border-l-2 border-foreground-300 bg-background-100 px-3 py-2">
                      <p className="font-label text-[10px] tracking-widest text-foreground-400">公开呈现</p>
                      <p className="mt-0.5 text-sm text-foreground-800">{item.before}</p>
                    </div>
                    <div className={`rounded-md border-l-2 px-3 py-2 ${tone.border} ${tone.softBg}`}>
                      <p className={`font-label text-[10px] tracking-widest ${tone.softText}`}>被记录片段</p>
                      <p className="mt-0.5 text-sm text-foreground-900">{item.after}</p>
                    </div>
                  </div>
                </div>

                <div className="mt-5 flex items-center justify-between border-t border-dashed border-foreground-300 pt-3">
                  <span className="font-label text-[11px] text-foreground-500">更新于 {item.date}</span>
                  <span className="flex items-center gap-1.5 font-label text-[11px] text-foreground-500">
                    <i className="ri-eye-line" />
                    {item.reads.toLocaleString()} 次阅读
                  </span>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}